// extracted by mini-css-extract-plugin
export default {"applicant-button":"style_applicant-button__EHlyh","priority":"style_priority__sTccz","year-options":"style_year-options__ef9C5"};